<template>
    <div :class="classList">
        <InputElm
            :inputConfig="inputConfig"
            v-on:input="emitInput"
            v-on:focus="focused = true"
            v-on:blur="focused = false"
            v-on:keydown="$emit('keydownHandler', e)"
            :keydownHandler="keydownHandler"></InputElm>
    </div>
</template>

<script>
    import InputElm from 'atoms/InputElm';

    export default {
        components: { InputElm },

        props: {
            inputConfig: {
                type: Object,
            },
            keydownHandler: {
                type: Function,
                default: () => {},
            },
        },

        data: function () {
            return {
                focused: false,
            };
        },

        computed: {
            classList: function () {
                return [
                    'field-wrapper',
                    'field-wrapper--' + this.inputConfig.id,
                    this.focused ? 'focused' : '',
                ];
            },
        },

        methods: {
            emitInput(event) {
                this.$emit('input', { value: event.value });
            },
        },
    };
</script>
